export default __webpack_public_path__ + "static/logo-reviews-17ccd1b496f76fe15d179157e482d6c5.png";